import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import { DeliveryIntervalSelectContainer } from '../../../components/DeliveryIntervalSelect/DeliveryIntervalSelectContainer.js';
import '@grandvisionhq/lib-visuals';
import '@swc/helpers';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

const SolutionsDeliveryIntervalSelect = ({ className  })=>{
    const { actions , state  } = useSolutionsEcommContext();
    const { deliveryInterval  } = state.configurations.subscriptionPurchaseConfigurations;
    // Get UI validation state for the delivery interval component
    const { deliveryInterval: { showError  } , invalidSubmissionsCount ,  } = state.configurator;
    React.useEffect(()=>{
        if (showError) {
            toast.failed('products.deliveryInterval.error');
        }
    }, [
        showError,
        invalidSubmissionsCount
    ]);
    return /*#__PURE__*/ React.createElement(DeliveryIntervalSelectContainer, {
        className: className,
        hasError: showError,
        deliveryInterval: deliveryInterval,
        onIntervalSelection: actions.updateDeliveryInterval
    });
};

export { SolutionsDeliveryIntervalSelect };
//# sourceMappingURL=SolutionsDeliveryIntervalSelect.js.map
